export {LicensingModule} from '@modules/licensing/core/licensing.module';
export {LicensingService} from '@modules/licensing/core/licensing.service';